import api from '../api';
const routes = require('routes.js.erb');

const createLicenseRequest = function({ commit }, organizationId) {
  return api.post(routes.license_request_api_v5_organization_path(organizationId));
};

const getLicenseRequests = function({ commit }, organizationId){
  return api.get(routes.license_requests_api_v5_organization_path(organizationId));
}

export {
  createLicenseRequest,
  getLicenseRequests
};
